export function TopBar({
  onToggleHistory,
  signedIn,
}: {
  onToggleHistory?: () => void;
  signedIn?: boolean;
}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 14px',
        borderBottom: '1px solid var(--line-1)',
        background: 'var(--bg-0)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <button
          type="button"
          onClick={onToggleHistory}
          aria-label="open history"
          style={{
            padding: '4px 8px',
            border: '1px solid var(--line-1)',
            borderRadius: 3,
            color: 'var(--fg-2)',
            fontSize: 14,
          }}
        >
          ☰
        </button>
        <a
          href="/"
          style={{
            fontFamily: 'var(--font-serif)',
            fontSize: 18,
            fontWeight: 500,
            color: 'var(--fg-1)',
            textDecoration: 'none',
          }}
        >
          vgcbuddy
        </a>
        <span className="caps mono" style={{ color: 'var(--fg-4)', fontSize: 9.5 }}>
          beta
        </span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <a
          href="/community"
          className="caps mono"
          style={{
            color: 'var(--fg-3)',
            fontSize: 9.5,
            padding: '4px 8px',
            border: '1px solid var(--line-1)',
            borderRadius: 3,
            letterSpacing: '0.08em',
          }}
        >
          community
        </a>
        {!signedIn ? (
          <a
            href="/account"
            className="caps mono"
            style={{
              color: 'var(--fg-3)',
              fontSize: 9.5,
              padding: '4px 8px',
              border: '1px solid var(--line-1)',
              borderRadius: 3,
              letterSpacing: '0.08em',
            }}
          >
            sign in
          </a>
        ) : (
          <a
            href="/account"
            className="caps mono"
            style={{
              color: 'var(--accent-2)',
              fontSize: 9.5,
              padding: '4px 8px',
              border: '1px solid var(--accent-line)',
              borderRadius: 3,
              letterSpacing: '0.08em',
            }}
          >
            account
          </a>
        )}
      </div>
    </div>
  );
}
